import { Component } from 'react'
import { connect } from 'react-redux'
import { updateProfileMnaFilters } from 'reducers/profile/reducer'

class FiltersObserver extends Component {
  shouldComponentUpdate(nextProps) {
    const { filters, updateProfileMnaFilters } = nextProps

    if (this.props.filters !== filters) {
      updateProfileMnaFilters({
        mna_filters: filters.toJS(),
      })
    }

    return false
  }

  render() {
    return null
  }
}

export default connect(
  state => ({
    filters: state.getIn(['profile', 'mnaFilters']),
  }),
  {
    updateProfileMnaFilters,
  },
)(FiltersObserver)
